import type { Position } from '@modules/advancement/duck/types';
import { toastService } from '@modules/toasts';

export function isSubUnitPosition(position: Position) {
  return Boolean(position.denId || position.patrolId || position.denNumber);
}

/**
 * Shows the toast for a failed authenticate call.
 */
export function handleAuthenticateError(error: {
  data?: { code?: string; message?: string };
}) {
  // idp-102 account locked
  if (error?.data?.code === 'client_41') {
    toastService.error(
      'Authentication failed. Please check your credentials and try again later.',
    );
  } else {
    toastService.error(error?.data?.message);
  }
}
